import clsx from 'clsx'
import React from 'react'
import Box from '@mui/material/Box'
import {faEdit} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import EditableCaption from './editable-caption'

export default function AssessmentTitle({context, className, onChange}) {
  const {translate, quizAssessment: assessment, action} = context
  const [editingTitle, setEditingTitle] = React.useState(false)
  const title = assessment.title || ''

  function onEditTitleClick () {
    setEditingTitle(action == 'edit' && true)
  }

  function closeEditTitle() {
    setEditingTitle(false)
  }

  async function handleTitleChange(title) {
    if (assessment.title != title) {
      onChange && onChange(title)
   }
  }

  return (<Box className={className} onClick={onEditTitleClick}>
    <Box className="titleLabel">{translate('title')}:</Box>
    <Box className="titleInput">
      <EditableCaption
        editing={editingTitle}
        value={assessment.title || ''}
        onCancel={closeEditTitle}
        onConfirm={title => handleTitleChange(title) && closeEditTitle()}
        className="inputTitle"
      />
    </Box>
    {action == 'edit' &&  (
      <Box className={clsx("icon",{"editing": editingTitle})}>
        <FontAwesomeIcon icon={faEdit} />
      </Box>
    )}
  </Box>)
}
